<div class="container py-3">
  <div class="d-flex justify-content-between align-items-center mb-3">
    <h1 class="h3 mb-0">Benachrichtigungen</h1>
    <button class="btn btn-sm btn-outline-primary" (click)="markAllAsRead()">Alle als gelesen markieren</button>
  </div>

  <!-- Filters -->
  <div class="card mb-3 shadow-sm">
    <div class="card-body py-2">
      <div class="row g-2">
        <div class="col-md-4">
          <div class="input-group input-group-sm">
            <span class="input-group-text bg-white border-end-0"><fa-icon [icon]="faSearch"></fa-icon></span>
            <input type="text" class="form-control border-start-0" placeholder="Suchen..."
                   [value]="searchTerm$ | async"
                   (input)="searchTerm$.next($any($event.target).value)">
          </div>
        </div>
        <div class="col-md-3">
          <select class="form-select form-select-sm" [value]="statusFilter$ | async" (change)="statusFilter$.next($any($event.target).value)">
            <option value="ALL">Alle Status</option>
            <option value="UNREAD">Ungelesen</option>
            <option value="READ">Gelesen</option>
            <option value="ARCHIVED">Archiviert</option>
          </select>
        </div>
        <div class="col-md-2">
          <select class="form-select form-select-sm" [value]="typeFilter$ | async" (change)="typeFilter$.next($any($event.target).value)">
            <option value="ALL">Alle Typen</option>
            <option value="SYSTEM">System</option>
            <option value="APPOINTMENT">Termine</option>
            <option value="MESSAGE">Nachrichten</option>
          </select>
        </div>
        <div class="col-md-1 d-flex align-items-center">
          <div class="form-check mb-0">
            <input class="form-check-input" type="checkbox" id="showArchived"
                   [checked]="showArchived$ | async"
                   (change)="showArchived$.next($any($event.target).checked)">
            <label class="form-check-label small" for="showArchived" style="font-size: 0.75rem; white-space: nowrap;">
              Archiv
            </label>
          </div>
        </div>
        <div class="col-md-2">
          <button class="btn btn-sm btn-outline-primary w-100" (click)="resetFilters()"><fa-icon [icon]="faFilter"></fa-icon> Reset</button>
        </div>
      </div>
    </div>
  </div>

  <!-- List -->
  <div class="notification-container">
    <div *ngIf="(totalCount$ | async) === 0" class="text-center py-5 bg-white rounded shadow-sm">
      <p class="text-muted mb-0">Keine Benachrichtigungen gefunden, die den Filtern entsprechen.</p>
    </div>

    <div *ngFor="let notification of (pagedNotifications$ | async)"
         class="card mb-2 shadow-sm notification-card clickable-card"
         [class.border-primary]="notification.status === 'UNREAD'"
         (click)="viewDetails(notification.id)">
      <div class="card-body py-2 px-3">
        <div class="d-flex flex-row align-items-center">
          <!-- Icon & Type -->
          <div class="me-3 d-flex align-items-center justify-content-center bg-light rounded-circle" style="width: 40px; height: 40px; flex-shrink: 0;">
            <fa-icon [icon]="getIconForType(notification.type)" [class]="getPriorityClass(notification.priority)"></fa-icon>
          </div>

          <!-- Content -->
          <div class="flex-grow-1 min-w-0">
            <div class="d-flex justify-content-between align-items-center">
              <div class="text-truncate">
                <h6 class="card-title mb-0 d-inline-flex align-items-center">
                  {{ notification.title }}
                  <span class="badge ms-2" [ngClass]="getStatusClass(notification.status)">
                    {{ notification.status }}
                  </span>
                </h6>
                <div class="card-text text-muted small text-truncate">{{ notification.message }}</div>

                <!-- Quick Actions -->
                <div *ngIf="notification.actions?.length" class="mt-1 d-flex gap-2">
                  <button *ngFor="let action of notification.actions"
                          class="btn btn-outline-primary btn-sm py-0 px-2"
                          style="font-size: 0.7rem; border-radius: 4px;"
                          (click)="handleAction(notification, action, $event)">
                    <fa-icon *ngIf="action.icon" [icon]="actionIcons[action.icon]" class="me-1 small"></fa-icon>
                    {{ action.label }}
                  </button>
                </div>
              </div>

              <!-- Date & Actions -->
              <div class="d-flex align-items-center ms-3 flex-shrink-0">
                <div class="small text-muted me-3 d-none d-md-block text-end">
                  <div *ngIf="notification.dueDate" class="text-danger fw-bold mb-0" title="Fälligkeit">
                    <fa-icon [icon]="faCalendarAlt"></fa-icon> {{ notification.dueDate | date:'dd.MM.yyyy HH:mm' }}
                  </div>
                  <div *ngIf="notification.reminderAt" class="text-warning mb-0" title="Erinnerung">
                    <fa-icon [icon]="faClock"></fa-icon> {{ notification.reminderAt | date:'dd.MM.yyyy HH:mm' }}
                  </div>
                  <div>{{ notification.createdAt | date:'dd.MM.yyyy HH:mm' }}</div>
                </div>

                <div class="btn-group btn-group-sm" (click)="$event.stopPropagation()">
                  <button *ngIf="notification.status === 'UNREAD'"
                          class="btn btn-light"
                          title="Als gelesen markieren"
                          (click)="markAsRead(notification.id)">
                    <fa-icon [icon]="faCheck" class="text-success"></fa-icon>
                  </button>
                  <button class="btn btn-light"
                          title="Erinnerung einstellen"
                          (click)="setReminder(notification.id)">
                    <fa-icon [icon]="faClock" class="text-primary"></fa-icon>
                  </button>
                  <button class="btn btn-light"
                          title="Archivieren"
                          (click)="archive(notification.id)">
                    <fa-icon [icon]="faArchive" class="text-secondary"></fa-icon>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Pagination -->
    <div class="d-flex justify-content-center mt-4" *ngIf="(totalCount$ | async) > pageSize">
      <ngb-pagination
        [collectionSize]="(totalCount$ | async)"
        [page]="(currentPage$ | async)"
        [pageSize]="pageSize"
        (pageChange)="currentPage$.next($event)"
        [maxSize]="5"
        [rotate]="true"
        [boundaryLinks]="true">
      </ngb-pagination>
    </div>
  </div>
</div>
